import React from "react";
import {CustomerFluidSubPageLayout} from "../../layouts/customerLayout/customerFluidSubPageLayout/CustomerFluidSubPageLayout";
import {useObserver} from "mobx-react-lite";
import {SubCompanyPaymentContractList} from "../../company/subCompanyDetail/subCompanyPaymentContracts/SubCompanyPaymentContractList";
import {useStore} from "../../../hooks/useStore";
import {CustomerMenuHeader} from "components/layouts/customerLayout/components/customerMenuHeader";

export const CustomerContractPage = () => {
    const stores = useStore();

    return useObserver(() => {
        const selectedSubCompanyId = stores.meStore.selectedSubCompanyId;

        return (
            <CustomerFluidSubPageLayout pageTitle="Sözleşme">
                <CustomerMenuHeader />
                {selectedSubCompanyId && (
                    <SubCompanyPaymentContractList subCompanyId={selectedSubCompanyId} />
                )}
            </CustomerFluidSubPageLayout>
        );
    });
};

export default CustomerContractPage;
